import { route, tag, type PageTour } from '../pageTour';

export const eventDetailTour: PageTour = {
  id: 'page-event-detail',
  version: 1,
  title: 'Event Details',
  summary: 'One AI detection in full, with its snapshot and camera.',
  match: route('/events/:model/:eventId'),
  steps: [
    {
      target: tag('event-record'),
      title: 'The full record',
      description: 'Snapshots, camera, time and everything the AI noticed about this event. Use the up and down arrow keys to step through its frames.',
      side: 'top',
    },
    {
      target: tag('event-back'),
      title: 'Back to the report',
      description: 'Return to the full report this event belongs to.',
      side: 'bottom',
    },
    {
      target: tag('event-refresh'),
      title: 'Refresh',
      description: 'Reload this event, for example if its snapshots were still arriving.',
      side: 'bottom',
    },
  ],
};
